<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="E. Analiza mediului extern"
                warn="Această secțiune include, acolo unde este cazul:
                                        <ul>
                                            <li>o descriere a sectorului relativ și a caracteristicilor sale economice și de mediu;</li>
                                            <li>factorii de schimbare a sectorului,</li>
                                            <li>factorii cheie de succes ai sectorului,</li>
                                            <li>perspective sectoriale,</li>
                                        </ul>"
            >
                <template v-slot:body>
                    <div class="textarea">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-textarea
                                v-model="form.external_environment"
                                rows="4"
                                max-rows="20"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                                @input="$emit('unsavedChanges', !!form.external_environment.length)"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <b-icon-pencil-square font-scale="1.2"></b-icon-pencil-square>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider, ValidationObserver
        },
        props: {
            mediuExtern: null,
        },
        data() {
            return {
                completed: null,
                form: {
                    external_environment: '',
                }
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriMediuExtern;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            mediuExtern: {
                handler() {
                    if(this.mediuExtern !== null && this.mediuExtern.business_plan_external_environment){
                        this.form.external_environment = this.mediuExtern.business_plan_external_environment
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.mediuExtern !== null && this.mediuExtern.business_plan_external_environment){
                this.form.external_environment = this.mediuExtern.business_plan_external_environment
            }
            else{
                this.form.external_environment = 'O ANALIZĂ EXTERNĂ (SAU ANALIZĂ A MEDIULUI) ESTE O EVALUARE OBIECTIVĂ A CONTEXTULUI VARIABIL ÎN CARE ACTIVEAZĂ O ÎNTREPRINDERE, CU SCOPUL DE A AVEA UN ”SISTEM DE ALERTĂ TIMPURIE” PENTRU IDENTIFICAREA POTENȚIALELOR PERICOLE SAU OPORTUNITĂȚI.\n' +
                    'Toate întreprinderile și organizațiile activează într-un mediu în schimbare și sunt expuse la forțe care sunt mai puternice decât ele și pe care nu le pot controla. Organizațiile sunt influențate de forțe din mediul de afaceri extern.\n' +
                    '\n' +
                    'Analiza forțelor externe în 4 categorii: Politică, economică, sociologică și tehnologică. Acestea categorii sunt utile; nu contează dacă unele elemente sunt atât politice, cât și economice (de ex. impozitele și cursul de schimb).\n' +
                    '\n' +
                    'Recomandare: Utilizati lista de verificare ICEDRIPS:\n' +
                    'Inovaţia, inclusiv noile tehnologii și internetul (desigur), dar și alte inovații care sunt specifice unui sector.\n' +
                    'Concurenţii. Nu numai rivalii direcți, dar și amenințările din partea produselor înlocuitoare, noilor veniți pe piață, capacităţii furnizorilor sau a clienţilor de a schimba regulile de joc. (Acești cinci factori sunt denumiți ”cele cinci forțe concurențiale”).\n' +
                    'Factorii economici, cum ar fi inflația, cursul de schimb, crizele economice, cheltuielile publice etc.\n' +
                    'Demografia. Statisticile relevante despre vârstă, gen, amplasare geografică, clasă socială etc., precum și schimbările demografice.\n' +
                    'Mediul de reglementare, adică legi, regulamente, acorduri și convenții.\n' +
                    'Infrastructura, cum ar fi rețelele de telecomunicație, transporturi, servicii publice şi servicii comunale.\n' +
                    'Partenerii. Alianțe strategice cu alte companii sau organizații.\n' +
                    'Tendințe sociale, inclusiv acceptarea tehnologiilor, utilizarea timpului liber, moda și convingerile în schimbare.'
            }
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{

                        this.formSend = {
                            business_plan_external_environment: {
                                business_plan_external_environment: this.form.external_environment,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriMediuExtern !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriMediuExtern', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
</style>
